/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";
import { forwardRef } from "react";
import s from "./Input.module.css";

const ColorInput = forwardRef((props, ref) => {
  const { className, isMissing, onBlur } = props;
  return (
    <div className="relative w-full" test-id="0fo3QRD8">
      <input
        type="color"
        ref={ref}
        className={cn(s.colorInput, className, {
          "border-alert": isMissing,
        })}
        onBlur={onBlur}
        test-id="Wzort5-K"
      />
    </div>
  );
});

export default ColorInput;
